const ja = {
   occupationCategory: "職業別",
  peopleDetail: "人材の詳細",
  easyCareer: "楽々キャリア",
  adminSystemAdmin: "システム管理者",
  memberLogin: "会員ログイン",
  emil: "メールアドレス",
  password: "パスワード",
  forgotPassword: "パスワードをお忘れ",
  verificationCode: "検証コード",
  login: "ログイン",
  upSuccess: "更新に成功しました",
  tipsEmail: "メールアドレスを入力してください",
  tipsPaw: "パスワードを入力してください。",
  tipsCode: "認証コードを入力してください。",
  changeMechanism: "メカニズムタイプを選択してください",
  errorMsg: "入力フォーマットが間違っています！",
  userMsg: "ユーザ認証済み",
  registration: "こちら",
  clickHere: "新規登録は",
  waringWorkPlace: "勤務地入力文字数が制限100ビットを超えている",
  waringQualification3: "資格3入力文字数が制限100ビットを超える",
  waringQualification1: "資格1入力文字数が制限100ビットを超える",
  errorCode: "ユーザ認証コードエラー",
  errorPw: "ユーザーまたはパスワードのエラー ",
  allName: "すべて",
  waringOther: "その他の入力文字数が制限100ビットを超えている",
  waringOtherHope: "その他入力したい文字数が255ビットを超えている",
  waringQualification2: "資格2入力文字数が制限100ビットを超える",
  startUsing: "有効化",
  waringHopeWorkplace: "優先職場入力文字数が制限100ビットを超える",
  passwordReissue: "パスワード再発行",
  passwordReissueTitle:
    "登録したメールアドレスをご入力ください。パスワード再設定ページのURLをメールで送ります。",
  send: "送信する",
  pleaseEmil: "正しいメールアドレスを入力してください",
  emilError: "電子メールの形式が正しくありません",
  specializedCare: "介護人材の専門サイト",
  hiringForeigners: "外国人採用経験豊富",
  conciseSystem: "簡潔なシステム、使いやすい",
  lookWait: "待つではなく、探す！",
  newRegistration: "新規会員登録",
  name: "名前",
  namejop: "新規追加",
  passwordRules: "長さ6〜18桁、数字と英語を含める必要があります",
  confirmPassword: "パスワードを確認",
  twoPassword: "2つのパスワードの内容が異なります",
  userNameRules: "4〜32桁のユーザー名を入力してください",
  yourRole: "ご立場",
  medicalInstitution: "医療機関",
  educationalInstitution: "教育機関",
  useRules: "利用規則",
  agreeToUse: "に同意して",
  toRegister: "登録する",
  alreadyRegistered: "すでに登録されている方には",
  clickHereGoTo: "こちら",
  homepost: "管理画面",
  jobPosting: "求人掲載",
  signUp: "新規登録",
  largestStaffing: "最大級介護人材紹介サイト",
  searchForAll: "医療機関、教育機関、求人案件、人材情報",
  search: "検索",
  jobSquare: "求人広場",
  talentPool: "人材一覧",
  jobOffer: "求人案件",
  institutionalInformation: "機関情報",
  ifRegisteredEnterName: "登録済みの場合、機関名をご入力",
  institutionName: "機関名",
  forNewEnterContents: "新規登録の場合、ここからの内容をご入力ください",
  postCode: "郵便番号",
  enterZipCode: "郵便番号をご入力",
  location: "所在地",
  enterAddress: "ご住所をご入力ください",
  institutionalAttributes: "機関属性",
  clinic: "診療所",
  generalHospital: "一般病院",
  communityMedicalHospital: "地域医療支援病院",
  specialFunctionHospital: "特定機能病院",
  paidNursingHome: "有料老人ホーム",
  housingElderly: "高齢者向け住宅",
  groupHome: "グループホーム",
  careHouse: "ケアハウス",
  specialElderlyNursing: "特別養護老人ホーム",
  longTermCare: "介護老人保健施設",
  longTermFacility: "介護療養型医療施設",
  homepageEtc: "ホームページ、Youtube、Facebook、Twitterなど",
  representativeName: "代表者",
  enterRepresentative: "代表者氏名をご入力",
  institutionalNumber: "電話番号",
  EnterPhoneNumber: "電話番号をご入力",
  registeredCapital: "資本金",
  oneMillionYen: "0-100万円",
  baiMillionYen: "101-500万円",
  fiveHundredMillionYen: "501−5000万円",
  FiveThousandMillionYen: "5001万円ー１億円",
  hundredMillion: "１億円−５億円",
  fiveHundredMillion: "５億円ー２０億円",
  twoBillion: "２０億円以上",
  noBed: "無床",
  institutionalInformationMain: "機関案内",
  signUpButton: "新規登録",
  LogImage: "ログ画像",
  numberStaff: "職員数",
  numberOfEmployees: "授業員数",
  numberOfBets: "病床数",
  institutionNumber: "機関番号",
  staffApplication: "スタッフ申請",
  managerApplication: "管理者申請",
  businessContent: "事業内容",
  toEdit: "編集",
  certified: "認証済",
  register: "登録",
  collection: "お気に入り",
  chatHistory: "トック履歴",
  pleaseEnterMessage: "メッセージをご入力ください",
  decideIfWantEmployee: "従業員の申し込みをするかどうかを決定してください",
  confirm: "確認",
  newInstitution: "新しい機関",
  staffManagement: "システムユーザー管理",
  GiveAdministrator: "管理者に与える",
  edit: "編集",
  delete: "削除",
  institutionalRegistrationFailed: "機関登録審査が失敗しました。",
  pleaseApplyResettingAgain: "もう一度再設定申し込みをしてください。",
  editAgain: "もう一度編集",
  institutionalRegistrationCompleted: "機関登録審査が完了しました。",
  close: "閉じる",
  reviewingInstitutionalRegistration: "機関登録を審査しております。",
  chooseRecommender: "推薦者を選ぶ",
  projectTitle: "案件名",
  occupationCategory: "職種",
  workLocation: "勤務地",
  employmentForm: "雇用形態",
  employmentForm2: "雇用形態2",
  employmentForm3: "雇用形態3",
  employmentForm4: "雇用形態4",
  give: "给予",
  dutyTime: "勤務時間",
  salary: "給与",
  numberOfHires: "採用人数",
  recruiter: "採用担当",
  targetRecruitmentTime: "目標採用時期",
  workContent: "仕事内容",
  welfare: "福利厚生",
  employmentConditions: "採用条件",
  other: "その他",
  humanResourcesPosting: "人材掲載",
  photograph: "jp写真",
  Fur: "フリガナ",
  employmentCharge: "就職担当",
  familyName: "氏名",
  sex: "性別",
  telephoneNumber: "電話番号",
  email: "メール",
  currentAddress: "現住所",
  japanese: "日本語",
  english: "英語",
  qualification1: "資格1",
  qualification2: "資格2",
  qualification3: "資格3",
  selfPR: "自己PR",
  temporarilySaved: "一時保存",
  next: "次へ",
  goodAtJapanese: "日本語上手",
  qualified: "資格あり",
  interviewAtAnytime: "随時面接",
  determined: "決心あり",
  postingJobOffer: "求人案件掲載",
  projectTitleName: "案件名",
  projectPhoto: "案件写真",
  oneSheet: "＋１枚目",
  twoSheet: "＋２枚目",
  threeSheet: "＋３枚目",
  foreignersWelcome: "外国人歓迎",
  inexperiencedOK: "未経験 OK",
  newGraduateOK: "新卒 OK",
  educationalBackgroundMatter: "学歴",
  salaryConditions: "給与・条件",
  return: "戻る",
  fullTimeEmployee: "正社員",
  partTimeJob: "アルバイト",
  specificSkill: "特定技能",
  technicalInternTrainee: "技能実習生",
  resume: "履歴書",
  careerRequest: "経歴・要望",
  dateAdmission: "入学年月",
  graduationDate: "卒業年月",
  school: "学校",
  major: "専門",
  startYear: "開始年月",
  endDate: "日付選択",
  workPlace: "勤務地",
  belongs: "所属",
  preferredWorkplace: "希望勤務地",
  desiredHireTime: "希望入社時間",
  desiredOccupationCategory: "希望職種カテゴリー",
  expectedSalary: "希望給与",
  otherWishes: "他のご希望",
  basicInformation: "基本情報",
  apply: "応募する",
  allCandidates: "応募者一覧",
  favoriteTalent: "お気に入り人材",
  favoriteMedical: "お気に入り医療機関",
  validatingRegistrationCode: "登録コードの確認",
  resetPassword: "パスワード再設定",
  newPassword: "新しいパスワード",
  enterPasswordAgain: "新しいパスワードを確認",
  newAdminRegistration: "管理者新規登録",
  avatarAddress: "アバターアドレス",
  status: "ステータス",
  newAdminAdd: "新規登録",
  certificationStatus: "認証ステータス",
  userName: "ユーザー名",
  userID: "ユーザーID",
  addInfo: "新規追加",
  popupPrompts: "ユーザー ID とユーザー パスワードを入力してください",
  talentManagement: "人材管理",
  new: "＋新規追加",
  changeState: "状態変更",
  peopleView: "要員一覧",
  selected: "選択済み",
  notSelected: "選択されていません",
  unpublished: "未公開",
  inTheReview: "審査中",
  nowPublished: "公開済み",
  disabled: "無効",
  completed: "完了",
  published: "公開中",
  stopUsing: "無効",
  viewJobInformation: "応募状況一覧",
  goToDetailPage: "詳細ページ",
  talk: "チャット",
  manyAchievements: "実績多数",
  programmingPossible: "編入可能",
  japaneseWindow: "日本窓口あり",
  japaneseVs: "日本語レベル",
  changeStatu: "状態変更",
  caseName: "案件名",
  educationId: "教育機関番号",
  inauguration: "担当者",
  medicId: "医療機関番号",
  talentNumber: "人材番号",
  caseNumber: "案件番号",
  fundingDayPayment: "応募日付",
  bookTestResults: "書類選考結果",
  date: "日付",
  faceAttending: "面接参加",
  medicalContractPreparation: "医療契約書作成",
  medicalResidencyEligibility: "医療レジデンシー資格",
  medicalEntry: "医療エントリー",
  medicalEnrollmentsSuccess: "医療登録（成功",
  MedicalEnrollmentSuccessTime: "医療登録（成功）時間",
  educationBookSelectionExamination: "教育図書選抜試験",
  educationalInterviewReview: "教育面接レビュー",
  educationalCompactPreparation: "教育コンパクトの準備",
  educationalEntry: "教育エントリー",
  educationallmentsSuccess: "教育登録（成功",
  educationalResidencyEligibility: "教育居住資格",
  operate: "操作",
  Completion: "作成時刻",
  typeOfWork: "職種",
  minimum: "最低賃金",
  workerNumner: "機関職員",
  maximumAmount: "最高給与",
  applyForDailyPayment: "申込日付",
  payonTheDay: "掲載日付",
  numberOfVisits: "観覧回数",
  senderNumber: "送信者番号",
  senderName: "送信者氏名",
  recipientNumber: "受信者番号",
  trusteeName: "受信者氏名",
  deliveryTime: "送信時刻",
  deliveryTimein: "開始日時",
  deliveryTimeout: "終了日時",
  chatSource: "チャット元",
  chatContent: "チャット内容",
  memberMumber: "社員番号",
  limit: "権限",
  numberOfCases: "担当案件数",
  已收藏请勿重复操作: "已收蔵繰り返し操作しないでください",
  //担当数
  userModification: "ユーザーの変更",
  mailSentSuccessfully: "メールは正常に送信されました",
  emailSendingFailed: "メール送信に失敗しました",
  MailSentSuccessfully: "メールは正常に送信されました",
  EmailSendingFailed: "メール送信に失敗しました",
  newPaw: "パスワードを入力してください",
  newEmail: "メールに記入してください",
  NewStaff: "新規追加",
  id: "ID",
  registerDay: "登録日付",
  registerDayselsect: "日付検索",
  lastUpdataDay: "更新時刻",
  lastLogin: "ログイン時刻",
  studentNumber: "学生人数",
  jobCaseNumber: "求人案件数",
  idCreater: "ID創設者",
  jobView:"履歴",
  //ID創設者
  belongsMedical: "所属医療機関",
  hopeToHireForm1: "フォーム1を採用したい1",
  hopeToHireForm2: "フォーム1を採用したい2",
  hopeToHireForm3: "フォーム1を採用したい3",
  hopeToHireForm4: "フォーム1を採用したい4",
  otherWant: "他のご要望",
  studentName: "学生名前",
  birth: "生年月日",
  candidates: "応募者",
  advance: "推進",
  recruitmentClassificationInformation: "募集区分情報",
  companyName: "公司名",
  monthlyIncome: "月収",
  seniorSchool: "専門学校",
  teacherNumber: "教員数",
  postTheLastLoginTimeOfThePostLeader: "投稿担当者の最終ログイン時刻",
  jobApplyView: "このケースの申請情報を見る",
  viewingTimes: "観覧回数 ",
  nursing: "介護",
  rehabilitation: "リハビリ",
  hospital: "病院",
  collectApplicationCases: "お気に入り応募",
  education: "学歴",
  logout: "ログアウト",
  successfulApplication: "応募に成功する",
  failulApplication: "重複応募があります",
  bedNumber: "病床数",
  fullName: "氏名",
  contactAddress: "連絡先",
  period: "期間",
  languageSkills: "言語力",
  qualification: "資格",
  workHistory: "職歴",
  affiliation: "所属",
  joinCompany: "入社",
  request: "要望",
  occupation: "職種",
  postingNewTalent: "+ 新規追加",
  male: "男",
  female: "女",
  newEducationUser: "教育機関のスタッフを追加",
  newMedicalUser: "新しい医療スタッフを追加",
  reviseEducationUser: "教育機関職員の変更",
  reviseMedicalUser: "医療機関職員の改造",
  noResults: "クエリ結果はまだありません",
  dataEmpty: "必須フィールドを空にすることはできません！",
  registrationAgreement:
    "募集単位、情報の配布者(総称して登録会社)と求職者、三者の行為は本契約の条項の制約を受けなければならない;\n" +
    "もしあなたが本契約の条項を受け入れないならば、本ウェブサイトを使用しないでください、さもなければ結果は自己責任です。\n" +
    "この協定は受け入れられ次第発効する。\n" +
    "1.情報の発信\n" +
    "関連法律規定、社会道徳に違反するいかなる情報を発表してはならない;\n" +
    "当サイトの求職、募集目的に適さない情報を発表してはならない。\n" +
    "いかなる不完全で、偽りの情報を発表してはならない;\n" +
    "ユーザーは、発行された情報の真正性、正確性、およびその結果について完全な責任を負う。\n" +
    "2情報の活用\n" +
    "采用会社は自会社の采用目的についてのみ求職者の履歴書情報を使用することができ、当サイトを使用しての代理募集を禁止する。\n" +
    "求職者はただある職位に応募するため、募集単位の発表する募集情報を使用することができます;\n" +
    "当サイトが提供する他の情報は、その対応するコンテンツに関連する目的でのみ使用される。\n" +
    "当サイトの情報を商業目的に利用することはできません。\n" +
    "いずれのユーザも、印刷、ダウンロード、コピー、または他の方法で他のユーザの認識可能な情報を再生してはならない。\n" +
    "上記のいずれの動作も、特定のユーザの同意なしに行うことは厳しく禁止される。\n" +
    "3.情報の公開\n" +
    "当サイトに登録されたいかなる情報も、当サイトを訪問された方に閲覧されたり、誤って使用されたりする可能性があります。\n" +
    "当サイトは責任を負いません。\n" +
    "4情報の正確性\n" +
    "当サイトに掲載される情報は、合法、正確、タイムリー、完全、真実の原則に合致しなければならない。\n" +
    "しかし、当サイトは、第三者によって提供された情報、または当サイトが収集した情報が完全に正確であることを保証することはできません。\n" +
    "使用者は、これらの情報の使用について、さらに確認する必要があることを理解する。\n" +
    "当サイトは、訪問者が自分で確認せずに当サイトの情報を誤用したことによるいかなる損失に対しても責任を負いません。\n" +
    "5情報の変更と削除\n" +
    "情報の発信者を除いて、いかなる訪問者も他人が発表したいかなる情報も変更したり削除してはならない。\n" +
    "当サイトは、その判断に基づいて、不都合な情報を修正または削除する権利を留保します。\n" +
    "6著作権、商標権\n" +
    "このウェブサイトの図形、画像、文字、音声、写真およびプログラム、広告のすべての内容、電子メールのすべての内容などはすべてwww.jobyp.comの著作権に属し、商標法および関連知的財産権の法律で保護されます。\n" +
    "www.jobyp.com書面の許可なしに、誰もダウンロード、コピー、再使用することはできません。\n" +
    "本サイトで情報を発信した商標は、該当商標の所有者に帰属し、商標法の保護を受けます。\n" +
    "7、登録情報の使用\n" +
    "注册の会員の提供した箇人情報はwww.jobyp.com統計、集約され、我々の厳格な管理の下で、www.jobyp.comの広告主とパートナーに根拠を提供します。\n" +
    "www.jobyp.comでは、より充実したサービスを提供するため、登録会員が残した電子メールで不定期に連絡を取り合う。\n" +
    "また、定期的にメールやメッセージ、メルマガを登録会員に配布しています。\n" +
    "www.jobyp.com承諾:訪問者の許可同意なしに、www.jobyp.comは訪問者の個人情報を第三者に漏洩しない。\n" +
    "ただし、次の場合を除く。\n" +
    "1)法執行机関の要求に基づいて、または公共の目的のために関系机関に箇人情報を提供する;\n" +
    "2)ユーザーパスワードを他人に教えたり、他人と共有してアカウントを登録したりすることで、箇人情報の漏洩につながる。\n" +
    "3)ハッカー攻撃、コンピューターウイルスの侵入や発生、政府の規制による一時的な閉鎖など、ネットワークの正常な経営に影響を与える不可抗力による個人情報の漏洩、紛失、盗用、改ざんなど。\n" +
    "4) www.jobyp.comにリンクされている他のウェブサイトによる個人情報の漏洩およびそれによるいかなる法的論争と結果;\n" +
    "5)訪問者の生命、身体又は財産上の差し迫った危険を免除するため。\n" +
    "8.自分を責める\n" +
    "本サイトをご利用のすべてのユーザーは、本サイトの情報をご利用いただいたり、本サイトに掲載された情報をご利用いただいたりすることについて、完全な責任を負います。\n" +
    "ユーザーは、www.jobyp.comにログインすること、またはwww.jobyp.comを介して他のサイトにログインすることによって生じるリスクをすべて独自に負担することに同意しなければならない。\n" +
    "他の人と情報をやり取りしたり、応募・募集の意向を発信したりすることによる結果は、すべてのユーザーが独立して負担します。\n" +
    "当社は、ユーザーが他のユーザーに送信する情報の真正性、正確性、信頼性を保証しません。\n" +
    "受け取った資料に対するユーザーの信頼はあくまでも個人的なリスクです。\n" +
    "www.jobyp.com本契約に違反したり、法律を侵害する行為を発見したら、すぐにそのユーザーのメンバーシップを解除し、本サイトへの再ログインを禁止する権利があります。\n" +
    "www.jobyp.comは、一切の違法、中傷、不健全な資料を削除する権利を留保する。\n" +
    "9.サービス終了\n" +
    "当サイトは、事前に通知する場合、または通知しない場合、無料サービスを終了する権利があります。\n" +
    "10.争議処理\n" +
    "当サイトは、通常のシステムメンテナンス、システムアップグレード、またはネットワーク混雑によりアクセスできなくなった場合、一切の責任を負いません。\n" +
    "本協議は中華人民共和国の法律の解釈に従う。\n" +
    "ユーザーとwww.jobyp.comの双方は中華人民共和国の司法管轄に従わなければならない。\n" +
    "本協議の関系条項が中華人民共和国法律に抵触する場合、当該条項は関系法律によって再解釈されるが、その他の条項は依然としてユーザーに対して法的効力と影響を及ぼす。\n" +
    "11.免責条項\n" +
    "当サイトはこのアドレスを常時監視するものではありませんが、リアルタイムで監視する権利は有しております。\n" +
    "他の人が入力したのは、本サイトが発表した材料ではありません、本サイトはいかなる法律責任を負いません。\n" +
    "応募する情報の発表者はその履歴書の中に心の箇人の履歴書と材料の形式、内容の正確性と合法性に対して独立してすべての法律の責任を引き受けなければなりません。\n" +
    "求人情報の配布者は、職位データベースに公表された資料に対して、独立して一切の法律責任を負う。\n" +
    "本網はある1種の職位に対して一定の数の使用者が閲覧することができることを保証しないで、また1人の特定の使用者が閲覧することができることを保証しません。\n" +
    "本サイトは、他のurlにリンクされている内容については一切法的責任を負いません。",
  projectApplicationDetails: "案件の応募詳細",
  documentScreening: "書類選考",
  interview: "面接",
  contract: "契約",
  statusOfResidence: "在留資格",
  travel: "渡航",
  joiningCompany: "入社",
  application: "応募案件",
  promotionStatus: "推進状況",
  contactHistory: "連絡履歴",
  citizen: "氏名",
  birthDay: "生年月日",
  applicationDate: "応募日",
  situationId: " 状態",
  applicantSide: "応募側",
  recruitmentSide: "募集側",
  pass: "合格",
  ng: "NG",
  medicalInstitutionsHaveOperated:
    "医療機関側確認済み",
  WaitingEducational: "教育機関側確認待ち",
  noSure: "システム審査NG",
  complete: "完成",
  waitingBothOperate: "確認待ち",
  EducationalOperatedMedicalInstitutionsOperate: "教育機関側確認済み",
  WaitingMedicalInstitution: "医療機関側確認待ち",
  applicationCompleted: "応募済み",
  educationalOperationCompleted: "教育機関側確認済み",
  medicalOperationCompleted: "医療機関側確認済み",
  educationalNotOperating: "教育機関側未確認",
  operationMedicalInstitutionFailed: "医療機関側未承認",
  educationalHavePassed: "教育機関側承認済み",
  educationalInstitutionsFailed: "教育機関側未承認",
  medicalNotOperating: "医療機関側未確認",
  medicalHavePassed: "医療機関側承認済み",
  dismiss: "辞退",
  consent: "承諾",
  adminReviewing: "システム審査中",
  adminFailed: "システム審査NG",
  adminLogin: "管理員ログイン",
  effortlessCareer: "楽々キャリア",
  success: "成功",
  fail: "不合格",
  choosingAnEducationalInstitution: "教育機関を選ぶ",
  successfullyDeleted: "正常に削除されました",
  failedToDelete: "削除できませんでした",
  pleaseSelectTheUserYouWantToDelete: "削除するユーザーを選択してください",
  loginFailed: "ログインに失敗しました",
  successfullyModified: "正常に変更されました",
  failToEdit: "編集に失敗する",
  save: "保存",
  signOut: "サインアウト",
  informationStatus: "ステータス",
  saveSuccess: "正常に保存されました！",
  saveFail: "保存できませんでした！",
  releaseSuccess: "正常に追加されました！",
  releaseFail: "追加に失敗しました！",
  NumberMedicalInstitutions: "医療機関数",
  NumberEducationalInstitutions: "教育機関数",
  applicationCaseNumber: "応募案件数",
  NumberJobOffers: "求人案件数",
  NumberOfPersonnel: "人材人数",
  NoticeToInstitutions: "機関へのお知らせ",
  serviceRequest: "サービス依頼",
  seeMore: "もっと見る",
  MattersProcessed: "処理事項",
  applicationReview: "申請審査",
  medicalInstitutionAudit: "医療機関監査",
  recruitmentReview: "採用審査",
  educationalInstitutionAudit: "教育機関の監査",
  loadingWord: "読み込み中",
  messageManagement: "メッセージ管理",
  applicationManagement: "応募管理",
  stateChange: "状態変更",
  medicalInstitutionManagement: "医療機関管理",
  eduInstitutionManagement: "教育機関管理",
  informationNotModified: "情報は変更されていません",
  emailRegistered: "メールが登録されました",
  endOfRecruitment: "募集終了",
  dataDictionary: "データ ディクショナリ",
  caseManagement: "案件管理",
  //后加
  selectEducationalAdministrator: "教育機関の管理者を選択する",
  hpOrSns: "HP or SNS",
  selectMedicalAdministrator: "医療機関管理者の選定",
  collectionManagement: "コレクション管理",
  chinese: "中国語",
  applicationStatus: "アプリケーションの状態",
  promise: "承諾",
  rejection: "拒否",
  uniquelyIdentifies: "識別コード",
  dataName: "作成者ID",
  creatorId: "名称",
  creatorName: "作成者",
  creationTime: "作成時間",
  dateItemAdd: "+新規追加",
  content: "コンテンツ",
  remark: "述べる",
  deleteState: "状態を削除",
  keyValue: "キー値",
  addDataDictionary: "データ ディクショナリを追加",
  addDataItem: "データ項目を追加",
  capital: "資本",
  yes: "yes",
  no: "no",
  Status: "ステータス",
  userId: "ユーザーID",
  ip: "IP",
  selectMedical: "医療機関を選ぶ",
  cancel: "キャンセル",
  selectAvatar: "アバターを選択してアップロードしてください",
  allApplications: "応募案件一覧",
  employeesNumber: "従業員数",
  businessIntroduction: "事業紹介",
  student: "学生",
  removeFavorite: "お気に入りから削除",
  imageSize:
    "アップロードするアバター画像のサイズは 2MB を超えることはできません!",
  selectImage: "画像ファイルを選択してください",
  selectMessage: "少なくとも 1 つのメッセージを選択してください",
  talent: "人才",
  inputEmailAddress: "メールアドレスを入力してください",
  enterPassword: "パスワードを入力してください",
  enterVerificationCode: "確認コードを入力してください",
  OnlyOneMessageSelected: "選択できるメッセージは 1 つだけです",
  selectLeastOneMessage: "少なくとも 1 つのメッセージを選択してください",
  enterAllInformation: "すべての情報を入力してください",
  inconsistentPasswordEnteredTwice: "矛盾したパスワードが 2 回入力されました",
  addedSuccessfully: "正常に追加されました",
  queryFailed: "クエリに失敗しました",
  changeNameEmpty: "名前の変更は空にできません",
  nameChangedSuccessfully: "名義変更成功",
  nameChangeFailed: "名前の変更に失敗しました",
  KeyModifiedSuccessfully: "キー値が正常に変更されました",
  failedModifyKeyValue: "キー値を変更できませんでした",
  failedModifyStatus: "データ項目のステータスを変更できませんでした",
  activated: "アクティブ化",
  hasStopped: "止まりました",
  pleaseSelectUser: "ユーザーを選択してください",
  AtMostOneUserSelected: "最大で 1 人のユーザーを選択できます",
  theUserAlreadyExists: "ユーザーはすでに存在します",
  addFailed: "追加できませんでした",
  successfulOperation: "成功した操作",
  operationFailed: "操作に失敗しました",
  pleaseEnterPasswordAgain: "パスワードをもう一度入力してください",
  collectionSuccess: "回収成功",
  submitABug: "バグを送信する",
  thisApplicationFavorite:
    "このアプリケーションはお気に入りに登録されています!",
  searchSuccessful: "検索成功",
  institutionDoesExistEmpty: "機関が存在しないか、クエリの入力が空です",
  bindingSucceeded: "バインド成功",
  noMoreData: "これ以上はありません",
  warningJobName: "案件名入力文字数が制限100ビットを超える",
  warningJobWorkSpace: "案件作業場所入力文字数が制限50ビットを超えている",
  warningJobWorkContent: "案件作業内容入力文字数が制限255ビットを超える",
  warningJobRecruitNumber: "案件採用人数入力タイプは数字で20桁以下",
  warningJobWorkTime: "案件作業時間入力文字数が制限100ビットを超える",
  jobDetail: "案件の詳細",
  dataMiss: "必要なデータが漏れています",
  warn: "に警告",
  question: "問題がある",
  warningJobEmploymentConditions:
    "案件採用条件入力文字数が制限255ビットを超える",
  //管理员新增机构输入提示
  warningEducationName: "教育機関名入力文字数が制限100桁を超える",
  warningEducationPost: "教育機関の郵便番号入力文字数が制限20桁を超える",
  warningEducationLocal: "教育機関所在地の入力文字数が制限255桁を超えている",
  warningEducationSns: "教育機関のWebサイトへの入力文字数が255桁を超えている",
  warningEducationRpName: "教育機関代表者名入力文字数が制限100桁を超える",
  warningEducationPhone: "教育機関の電話入力文字数が制限20桁を超える",
  warningMedicalName: "医療機関名入力文字数が制限100桁を超える",
  warningMedicalPost: "医療機関の郵便番号入力文字数が制限20桁を超える",
  warningMedicalLocal: "医療機関所在地の入力文字数が255桁を超えている",
  warningMedicalSns: "医療機関のWebサイト入力文字数が255ビットを超えている",
  warningMedicalRpName: "医療機関代表者名入力文字数が制限100桁を超える",
  warningMedicalPhone: "医療機関の電話入力文字数が制限20桁を超える",
  sureAboutThisOperation: "この操作を確認しますか？",
  collectType: "コレクションのタイプ",
  id: "番号",
  reviewed: "レビュー済み",
  chooseRow: "操作データを選択してください",
  changeStatus: "ステータス変更に成功しました",
  collectId: "コレクション番号",
  addNone:
    "この部署にバインドされているデータは存在しません。データをチェックしてください",
  addCheck:
    "新規参入に失敗した場合は、部署や人材が存在し、状態が正常かどうかをチェックしてください",
  addHave: "応募はすでに存在します",
  institutionalPlaceholder: "機関の経緯について方針特徴についてスローガンなど",
  userInstitutionalFailed:'機関はバインド要求を拒否します。バインド要求を再発行するか、機関を作成してください',
  userApplying:'機関がバインド購買依頼を処理しています',
  onlyNormalUsers: "通常のユーザーのみ操作可能",
  inputWord1: "機関名入力文字数が制限100ビットを超える",
  inputWord2: "番号入力文字数が制限32ビットを超えている",
  inputWord3: "アドレス入力文字数が制限255ビットを超える",
  inputWord4: "HP入力文字数が制限255ビットを超える",
  inputWord5: "代表者名入力文字数が制限255ビットを超えている",
  inputWord6: "機関電話入力文字数が制限20ビットを超える",
  inputWord7: "機構情報入力文字数が制限255ビットを超える",
  inputwords:"必須オプションを入力してください",
  warning:"警告",
  warningText:"必要なデータが漏れています",
  determine:"を選択して、",
  authentication:"資格認定に成功しました",
  waringAnonym:"名前または名を入力してください入力文字数が50桁を超えています",
  waringName:"入力文字数が制限50ビットを超えているか入力してください",
  waringTelephone:"電話番号または電話番号を入力してください入力文字数が20桁を超えています",
  waringEmail:"メールボックスまたはメールボックスを入力してください入力文字数が100桁を超えています",
  waringAddress:"住所または住所を入力してください入力文字数が制限100ビットを超えています",
  waringPr:"自己紹介または自己紹介を入力してください入力文字数が255桁を超えています",
  waringSchool:"学校を選んでください",
  waringProfession:"専門または専門の入力文字数を100桁以上入力してください",
  waringType: "機関を選択してください",
  waringStartSalary:"開始賃金または開始賃金を入力してください入力文字数が制限11桁を超えています",
  waringEndSalary: "終了賃金を入力するか、終了賃金を入力してください。入力文字数が11桁を超えています。",
  warningJobSalary: "案件給与または案件給与入力タイプを20桁以内の数値で入力してください",
  warningJobWelfareTreatment: "案件福利厚生または案件福利厚生の入力文字数が255ビットを超えていることを入力してください",
  warningJobOther: "案件の他の情報または案件の他の情報を入力してください入力文字数が255ビットを超えています",

};
export default ja;



// WEBPACK FOOTER //
// ./src/locale/ja-JP.js